/* eslint-disable no-underscore-dangle */
/**
 * 记录每页各个执行完成的动画的平均FPS
 */

export default class FPSRecord {
    // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
    public static timeIntervel = 16.666666666666667;
    public static durations = 0;
    public static times = 0;
    public static animeCount = 0;
    public static elementCount = 0;

    public static add(duration, times) {
        if (duration && times) {
            this.durations += duration;
            this.times += times;
            this.animeCount += 1;
        }
    }

    public static clear() {
        this.durations = 0;
        this.times = 0;
        this.animeCount = 0;
    }

    public static fps() {
        if (this.durations === 0 || this.times === 0) {
            return -1;
        }
        // window && window.log && window.log.info('~_~', this.times, this.durations);
        let fps = Math.ceil((this.times * this.timeIntervel) / this.durations * 60);
        if (fps > 60) {
            fps = 0;
        }
        this.clear();
        return fps;
    }
}
